import { useCallback, useMemo } from "react";
import trpc from "@/utils/trpc";

/**
 * React hook that returns a memoized Set of completed itemIds
 */
export default function useCompletedByItemId() {
  const {
    data: progression,
    isPending: isProgressionPending,
    isFetching: isProgressionFetching,
    isSuccess: isProgressionSuccess,
    isError: isProgressionError,
    error: progressionError,
  } = trpc.progression.get.useQuery(undefined, { staleTime: Infinity });
  const completedByItemId = useMemo(() => {
    const set = new Set<string>();
    if (!progression) return set;
    for (const item of progression) {
      if (item.completed) {
        set.add(item.canvasItemId);
      }
    }
    return set;
  }, [progression]);
  const isCompleted = useCallback(
    (itemId: string | null) => (itemId ? completedByItemId.has(String(itemId)) : false),
    [completedByItemId],
  );
  return {
    completedByItemId,
    isCompleted,
    isProgressionPending,
    isProgressionFetching,
    isProgressionSuccess,
    isProgressionError,
    progressionError,
  } as const;
}
